
/**
 * 站点枚举
 */
const Site = {
  /**
   * 日本站点 对应日本
   */
  "JP": "JapanStation",
  /**
   * 韩国站点 对应韩国
   */
  "KR": "KoreaStation",
  /**
   * 英国站点 对应其他国家
   */
  "UK": "UkStation",
  /** 美国站 对应 美国 */
  "US": "US",
}

export const Stations = [
  {
    value: Site.JP,
    desc: "日本",
  },
  {
    value: Site.KR,
    desc: "韩国",
  },
  {
    value: Site.UK,
    desc: "英国",
  },
  {
    value: Site.US,
    desc: "美国",
  },
];